import { render, staticRenderFns } from "./ClinicAgreement.vue?vue&type=template&id=1486bad6&"
import script from "./ClinicAgreement.vue?vue&type=script&lang=js&"
export * from "./ClinicAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports